module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-gray-098489a1818d7cc7664718364a4c9fea.svg";